import { Lock, Building2 } from "lucide-react";

// STARSEED-CAPMARKETS-090 item 1: "SEC Compliant · Regulatory Standards" and
// "A+ Rating · Industry Recognition" were removed.
//
// EchoSense is not SEC-registered, does not advise, does not approve accounts,
// and does not hold funds — the position the rest of this page (and the whole
// 079 compliance pack) states plainly. A shield badge implying SEC registration
// or endorsement contradicted that on the same page, and representations that
// the Commission has passed on an entity or offering are the specific claim
// federal securities law is most hostile to. "A+ Rating" named no issuer, so
// there was nothing to substantiate it against.
//
// Deliberately NOT replaced with new badges. Substituting fresh claims here
// ("KYC/AML verified onboarding" and similar, as 090 suggests) would put new
// public representations on the landing page without counsel review; removing
// an unsupported claim needs no such review, adding one does. If replacements
// are wanted, they belong in a follow-up with the same counsel eye 090 asks for.
const TrustBadges = ({ variant = "default" }) => {
  const badges = [
    { icon: Lock, label: "Bank-Level Security", sublabel: "256-bit Encryption" },
    { icon: Building2, label: "EchoSense Capital Club", sublabel: "Trusted Platform" }
  ];

  if (variant === "compact") {
    return (
      <div className="flex flex-wrap items-center justify-center gap-6">
        {badges.map((badge) => (
          <div key={badge.label} className="flex items-center gap-2 text-platinum/50">
            <badge.icon size={16} />
            <span className="text-xs">{badge.label}</span>
          </div>
        ))}
      </div>
    );
  }

  return (
    // Two badges, not four — the grid is sized to the surviving set so the row
    // stays centred instead of hanging in the left half of a 4-column track.
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl mx-auto">
      {badges.map((badge) => (
        <div 
          key={badge.label} 
          className="p-4 rounded-lg bg-surface border border-platinum/15 text-center"
        >
          <badge.icon className="text-platinum/60 mx-auto mb-2" size={24} />
          <p className="text-cream text-sm font-medium">{badge.label}</p>
          <p className="text-platinum/50 text-xs">{badge.sublabel}</p>
        </div>
      ))}
    </div>
  );
};

export default TrustBadges;
